<template>
  <div class="news-home">
    <div class="news-home-sticky-header">
      <header class="topbar">
        <div class="topbar-left">
          <span class="topbar-link" @click="showCustomerQrcode">提交</span>
          <!-- <span>广告</span> -->
          <el-dropdown
            ref="locationDropdown"
            trigger="click"
            :visible.sync="locationDropdownVisible"
            @command="handleLocationChange"
          >
            <span class="country">
              <img class="flag-cn" :src="icons.flag" alt="国旗">
              {{ currentLocation }}
              <i class="el-icon-arrow-down country-arrow" />
            </span>
            <el-dropdown-menu slot="dropdown" class="news-home-location-dropdown">
              <div class="popular-regions-header">
                <span class="header-label">热门地区</span>
                <div class="popular-regions">
                  <span
                    v-for="region in popularRegions"
                    :key="region.value"
                    class="popular-region-item"
                    :class="{ active: currentLocation === region.label }"
                    @click="handleLocationChange(region.value)"
                  >
                    {{ region.label }}
                  </span>
                </div>
              </div>
              <div class="region-categories">
                <div
                  v-for="category in regionCategories"
                  :key="category.name"
                  class="region-category"
                >
                  <div class="category-name">{{ category.name }}</div>
                  <div class="region-items">
                    <span
                      v-for="region in category.regions"
                      :key="region.value"
                      class="region-item"
                      :class="{ active: currentLocation === region.label }"
                      @click="handleLocationChange(region.value)"
                    >
                      {{ region.label }}
                    </span>
                  </div>
                </div>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="topbar-right">
          <template v-if="!isLoggedIn">
            <button class="btn-blue-outline" @click="memberAuthVisible = true">用户登录/注册</button>
            <button class="btn-blue" @click="proAuthVisible = true">造价师/供应商登录/注册</button>
          </template>
          <el-dropdown
            v-else
            ref="userDropdown"
            :visible.sync="userDropdownVisible"
            class="user-avatar-dropdown"
            trigger="click"
          >
            <div class="avatar-wrapper">
              <img
                :src="displayAvatar"
                class="user-avatar"
                alt=""
              >
              <div class="user-info-wrapper">
                <div class="user-name-line">
                  <span class="username">{{ displayUsername }}</span>
                  <span class="identity-chip">{{ identityRoleLabel }}</span>
                  <presence-selector variant="navbar-inline" />
                </div>
                <span v-if="userInfo.is_member === 1" class="member-badge">
                  <span class="member-days">剩余{{ userInfo.member_days_remaining || 0 }}天</span>
                </span>
              </div>
              <img class="dropdown-arrow" src="@/assets/image/xia2.png" alt="">
            </div>
            <el-dropdown-menu slot="dropdown" class="news-home-user-dropdown">
              <div class="user-info-section">
                <div class="user-avatar-info">
                  <img :src="displayAvatar" class="dropdown-avatar" alt="">
                  <div class="user-details">
                    <div class="username">{{ displayUsername }}</div>
                    <div class="user-status">
                      <span v-if="userInfo.group_id === 1 && userInfo.is_member === 1" class="status-badge member-status">
                        会员
                        <span class="member-days-text">(剩余{{ userInfo.member_days_remaining || 0 }}天)</span>
                      </span>
                      <span v-else class="status-badge role-badge">
                        {{ identityRoleLabel }}
                      </span>
                    </div>
                    <presence-selector variant="navbar-dropdown" />
                  </div>
                </div>
                <el-button class="logout-btn" size="small" @click="logout">退出</el-button>
              </div>

              <div
                v-if="userInfo.group_id === 1"
                style="padding: 0 20px;position: relative; cursor: pointer;"
                @click="goToMembership"
              >
                <img class="membership-section" src="@/assets/image/vip1.png" alt="VIP图标">
                <div v-if="userInfo.is_member === 1" class="vip-text">
                  {{ userInfo.member_days_remaining || 0 }}天到期
                </div>
                <div v-else class="vip-text">开通</div>
              </div>

              <div class="profile-options">
                <div class="option-item" @click="goToRealNameAuth">
                  <img src="@/assets/image/smrz.png" alt="实名认证" class="option-icon">
                  <span class="option-text">实名认证</span>
                  <img src="@/assets/image/you.png" alt="箭头" class="arrow-icon">
                </div>
                <div class="option-item" @click="goToWallet">
                  <img src="@/assets/image/qianboa.png" alt="钱包" class="option-icon">
                  <span class="option-text">钱包</span>
                  <img src="@/assets/image/you.png" alt="箭头" class="arrow-icon">
                </div>
                <div class="option-item" @click="goToSettings">
                  <img src="@/assets/image/set.png" alt="设置" class="option-icon">
                  <span class="option-text">设置</span>
                  <img src="@/assets/image/you.png" alt="箭头" class="arrow-icon">
                </div>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
          <navbar-auth-dialog :visible.sync="memberAuthVisible" mode="member" @success="onAuthSuccess" />
          <navbar-auth-dialog :visible.sync="proAuthVisible" mode="professional" @success="onAuthSuccess" />
          <img
            class="topbar-msg-btn"
            src="@/assets/image/news.png"
            alt="消息"
            @click="goToMsg"
          >
        </div>
      </header>

      <section class="brand">
        <div class="brand-logo-wrap">
          <img class="brand-logo" :src="brandLogo" alt="logo">
        </div>
        <div class="brand-name">智蜂制造</div>
      </section>

      <div class="sticky-nav-panel">
        <div class="tabs">
          <template v-for="(item, index) in navTabItems">
            <span
              :key="`tab-${item.id}`"
              class="tab-link"
              @click="handleNavClick(item)"
            >{{ getNavDisplayName(item.name) }}</span>
            <span
              v-if="index < navTabItems.length - 1"
              :key="`divider-${item.id}`"
              class="tab-divider"
              aria-hidden="true"
            />
          </template>
          <span class="search-box" :class="{ 'is-focused': searchFocused }">
            <input
              v-model="searchKeyword"
              class="search-line"
              type="text"
              :placeholder="searchFocused ? '' : '现在搜索智峰prime----“您的专属造价AI”'"
              @focus="searchFocused = true"
              @blur="searchFocused = false"
              @keyup.enter="handleSearch"
            >
            <span class="search-box-divider" aria-hidden="true" />
            <button type="button" class="search-trigger" aria-label="搜索" @click="handleSearch">
              <svg class="search-trigger-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <circle cx="10.5" cy="10.5" r="6.5" stroke="currentColor" stroke-width="1.8" />
                <path d="M15.5 15.5L20 20" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
              </svg>
            </button>
          </span>
        </div>
      </div>
    </div>

    <section class="panel panel-first">
      <div class="panel-body">
        <div class="left">
          <div class="title">时刻与您的项目案例！ &gt;&gt;</div>
          <div class="cases-wrap">
            <div class="cases-main">
              <div v-if="casesLoading" class="section-loading">加载中...</div>
              <div v-else-if="caseDisplayGroups.length === 0" class="section-empty">暂无推荐案例</div>
              <div v-for="group in caseDisplayGroups" v-else :key="group.title" class="group">
                <div class="group-title">{{ group.title }}</div>
                <div class="case-row">
                  <div
                    v-for="item in group.items"
                    :key="item.id"
                    class="case-item"
                    @click="viewCaseDetail(item)"
                  >
                    <img
                      class="thumb"
                      :src="$getImageUrl(item.cover_image || item.image) || images.zhuzhai"
                      :alt="item.title"
                    >
                    <div class="text">{{ item.title }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="cases-more">
              <div class="more-q">想看您的项目造价指标和更多信息？</div>
              <a class="more-link" href="javascript:void(0)" @click.prevent="goToCostcases">阅读更多》</a>
            </div>
          </div>
          <div class="title">即刻开始您的造价师服务！ &gt;&gt;</div>
          <div class="experts">
            <div v-if="engineersLoading" class="section-loading">加载中...</div>
            <div v-else-if="engineers.length === 0" class="section-empty">暂无造价师数据</div>
            <div
              v-for="item in engineers"
              v-else
              :key="item.id"
              class="expert-card"
              @click="goToEngineerDetail(item)"
            >
              <img class="expert-photo" :src="$getImageUrl(item.avatar) || images.zjs1" :alt="item.name">
              <div class="expert-meta">
                <div class="expert-title">{{ item.name }}</div>
                <div class="expert-sub">{{ item.title || '造价师' }}</div>
                <div class="expert-sub">{{ item.enterprise_text || '组织' }}</div>
                <div v-if="item.region" class="expert-sub">{{ item.region }}</div>
                <div v-if="item.introduction" class="expert-sub">{{ item.introduction }}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="showQuotesPanel" class="right">
          <template v-for="(quote, index) in quotes">
            <div
              v-if="quote.content && String(quote.content).trim()"
              :key="`quote-${index}`"
              class="quote-block"
              :class="{ second: index === 1 }"
            >
              <div class="quote">"{{ quote.content }}"</div>
              <div class="author">—{{ quote.author }}</div>
              <div class="arrows" @click="refreshQuote(index)">
                <img class="arrow-icon" :src="icons.arrow" alt="切换">
              </div>
            </div>
          </template>
        </div>
      </div>
    </section>

    <section class="panel second">
      <div class="panel-body second-panel">
        <div class="left">
          <div class="intro-box">
            <h3>现在为您介绍智蜂，我们拥有：</h3>
            <ul>
              <li>一个基于专业造价数据服务的AI</li>
              <li>一个开放式的问答社区</li>
              <li>一群为您解决问题的造价师</li>
            </ul>
          </div>
          <template v-if="showTeamSection">
            <div class="team-title">管理团队</div>
            <div class="team-row">
              <div
                v-for="member in teamList"
                :key="member.id"
                class="team-card"
              >
                <img class="avatar" :src="getTeamAvatar(member.avatar)" :alt="member.name">
                <div class="team-meta">
                  <div class="team-head">
                    <div class="team-name">{{ member.name }}</div>
                    <div class="team-role">{{ member.position }}</div>
                  </div>
                  <div class="team-bio">{{ member.bio }}</div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div class="right stats">
          <div class="metric"><b>{{ statistics.cost_engineer_count }}+</b> 平台入驻造价师数量</div>
          <div class="metric"><b>{{ statistics.monthly_customer_problem_count }}+</b> 每月解决客户问题数量</div>
          <div class="metric"><b>{{ statistics.major }}+</b> 覆盖专业数量</div>
          <div class="divider" />
          <div class="city-title">地点</div>
          <div class="city-grid">
            <span
              v-for="city in cities"
              :key="city"
              class="city-item"
              :class="{ active: isCityActive(city) }"
              @click="handleCityClick(city)"
            >{{ city }}</span>
          </div>
          <p class="city-tip">和中文圈的世界造价师相遇！</p>
        </div>
      </div>
    </section>

    <div class="news-home-footer">
      <Footer background-color="#ffffff" />
    </div>

    <el-dialog
      title="联系客服"
      :visible.sync="qrcodeDialogVisible"
      width="300px"
      :close-on-click-modal="true"
      center
    >
      <div v-if="qrcodeUrl" style="text-align:center;">
        <img :src="$getImageUrl(qrcodeUrl)" alt="客服二维码" style="width:220px;max-width:100%;margin:0 auto;display:block;">
        <div style="margin-top:10px;color:#999;">微信扫码联系客服</div>
      </div>
      <div v-else style="height:220px;display:flex;align-items:center;justify-content:center;">加载中...</div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getTopNav, getEngineerList } from '@/api/user'
import { getRandomQuote, getTeamList, getIndexStatistic, getCustomerQrcode } from '@/api/home'
import { getRecommendCostCase } from '@/api/costcase'
import { isAuthenticated } from '@/utils/auth'
import { getNavbarRegionLabel, getSelectedRegion, setRegionFromNavbar, setSelectedCity } from '@/utils/region'
import { popularRegions, regionCategories } from '@/utils/regionOptions'
import NavbarAuthDialog from '@/components/NavbarAuthDialog.vue'
import PresenceSelector from '@/components/PresenceSelector.vue'
import Footer from '@/layout/components/Footer.vue'

const NAV_PATH_MAP = {
  '材价信息': '/material',
  '造价案例': '/costcases',
  '造价师服务': '/service',
  '造价问答': '/costqa',
  '个人中心': '/profile'
}

const DEFAULT_NAV_LINKS = [
  { id: 1, name: '材价信息', path: '/material' },
  { id: 2, name: '造价案例', path: '/costcases' },
  { id: 3, name: '造价师服务', path: '/service' },
  { id: 4, name: '造价问答', path: '/costqa' },
  { id: 6, name: '个人中心', path: '/profile' }
]

const TAB_ORDER = [2, 3, 4, 1]

const DEFAULT_STATISTICS = {
  cost_engineer_count: 150,
  monthly_customer_problem_count: 1000,
  major: 45
}

/** 地点网格点击 → 地区选择（与顶部地区下拉一致） */
const CITY_CLICK_MAP = {
  北京: { primary: '北京' },
  上海: { primary: '上海' },
  杭州: { primary: '浙江省', city: '杭州市' },
  武汉: { primary: '湖北省', city: '武汉市' },
  广州: { primary: '广东省', city: '广州市' },
  深圳: { primary: '广东省', city: '深圳市' },
  嘉兴: { primary: '浙江省', city: '嘉兴市' },
  四川: { primary: '四川省' },
  河南: { primary: '河南省' },
  河北: { primary: '河北省' },
  山东: { primary: '山东省' },
  云南: { primary: '云南省' },
  香港: { primary: '香港特别行政区' },
  澳门: { primary: '澳门特别行政区' },
  台湾: { primary: '台湾省' },
  新加坡: { primary: '亚洲' },
  非洲: { primary: '非洲' },
  欧洲: { primary: '欧洲' },
  美洲: { primary: '美洲' }
}

export default {
  name: 'NewsHome',
  components: { NavbarAuthDialog, PresenceSelector, Footer },
  data() {
    return {
      memberAuthVisible: false,
      proAuthVisible: false,
      userDropdownVisible: false,
      currentLocation: '全国',
      locationDropdownVisible: false,
      popularRegions,
      regionCategories,
      navLinks: [],
      searchKeyword: '',
      searchFocused: false,
      qrcodeDialogVisible: false,
      qrcodeUrl: '',
      brandLogo: require('@/assets/logo.png'),
      recommendedCases: [],
      casesLoading: false,
      engineers: [],
      engineersLoading: false,
      quotes: [
        { content: '', author: '' },
        { content: '', author: '' }
      ],
      quotesReady: false,
      teamList: [],
      teamLoading: false,
      statistics: { ...DEFAULT_STATISTICS },
      icons: {
        flag: require('@/assets/news_home/guoqi.png'),
        avatar: require('@/assets/news_home/touxiang.png'),
        command: require('@/assets/news_home/icon.png'),
        arrow: require('@/assets/news_home/jiantou.png')
      },
      images: {
        zhuzhai: require('@/assets/news_home/zhuzhai.png'),
        zjs1: require('@/assets/news_home/zjs1.png'),
        zjs2: require('@/assets/news_home/zjs2.png')
      },
      cities: [
        '北京', '上海', '杭州', '武汉', '广州', '深圳',
        '嘉兴', '四川', '河南', '河北', '山东', '云南',
        '香港', '澳门', '台湾', '新加坡', '非洲', '欧洲', '美洲'
      ]
    }
  },
  computed: {
    ...mapGetters(['avatar', 'username', 'userInfo', 'token']),
    isLoggedIn() {
      return !!this.token
    },
    displayAvatar() {
      const avatarUrl = this.avatar || this.userInfo.avatar
      if (avatarUrl) {
        return avatarUrl.startsWith('http') ? avatarUrl : this.$getImageUrl(avatarUrl)
      }
      return require('@/assets/image/logo.png')
    },
    displayUsername() {
      if (!this.token) {
        return ''
      }
      return this.username || this.userInfo.nickname || '用户'
    },
    identityRoleLabel() {
      const g = Number(this.userInfo.group_id)
      if (g === 2) return '造价师'
      if (g === 3) return '供应商'
      return '会员'
    },
    navTabItems() {
      const source = this.navLinks.length ? this.navLinks : DEFAULT_NAV_LINKS
      const tabs = source.filter(item => item.path !== '/profile')
      return TAB_ORDER
        .map(id => tabs.find(item => item.id === id))
        .filter(Boolean)
    },
    caseDisplayGroups() {
      if (!this.recommendedCases.length) return []
      const groups = []
      for (let i = 0; i < this.recommendedCases.length && groups.length < 2; i += 2) {
        groups.push({
          title: groups.length === 0 ? '推荐案例' : '精选案例',
          items: this.recommendedCases.slice(i, i + 2)
        })
      }
      return groups
    },
    showQuotesPanel() {
      if (!this.quotesReady) return false
      return this.quotes.some(q => q.content && String(q.content).trim())
    },
    showTeamSection() {
      return !this.teamLoading && this.teamList.length > 0
    }
  },
  created() {
    this.currentLocation = getNavbarRegionLabel() || '全国'
    if (isAuthenticated()) {
      this.fetchUserProfile()
    }
    this.fetchNavLinks()
    this.fetchRecommendCases()
    this.fetchEngineers()
    this.fetchInitialQuotes()
    this.fetchTeamList()
    this.fetchStatistics()
  },
  mounted() {
    window.addEventListener('region-changed', this.syncLocationFromStore)
  },
  beforeDestroy() {
    window.removeEventListener('region-changed', this.syncLocationFromStore)
  },
  methods: {
    syncLocationFromStore() {
      this.currentLocation = getNavbarRegionLabel() || '全国'
      this.fetchRecommendCases()
      this.fetchEngineers()
    },
    isCityActive(city) {
      const config = CITY_CLICK_MAP[city]
      if (!config) return false
      const region = getSelectedRegion()
      const label = getNavbarRegionLabel()
      if (config.city) {
        return region === config.city
      }
      return label === config.primary
    },
    handleCityClick(city) {
      const config = CITY_CLICK_MAP[city]
      if (!config) return
      setRegionFromNavbar(config.primary)
      if (config.city) {
        setSelectedCity(config.city)
      }
      this.syncLocationFromStore()
      this.$message.success(`已切换到${city}`)
    },
    handleLocationChange(location) {
      let foundRegion = this.popularRegions.find(opt => opt.value === location)
      if (!foundRegion) {
        for (const category of this.regionCategories) {
          foundRegion = category.regions.find(opt => opt.value === location)
          if (foundRegion) break
        }
      }
      const label = foundRegion?.label || '全国'
      setRegionFromNavbar(label)
      this.syncLocationFromStore()
      this.locationDropdownVisible = false
      this.$nextTick(() => {
        if (this.$refs.locationDropdown && typeof this.$refs.locationDropdown.hide === 'function') {
          this.$refs.locationDropdown.hide()
        }
      })
      this.$message.success(`已切换到${this.currentLocation}`)
    },
    getNavDisplayName(name) {
      return name === '造价案例' ? '项目案例' : name
    },
    goToCostcases() {
      this.handleSearch()
    },
    handleSearch() {
      const keyword = (this.searchKeyword || '').trim()
      this.$router.push({
        path: '/costcases/index',
        query: keyword ? { keyword } : {}
      })
    },
    viewCaseDetail(caseItem) {
      this.$router.push({
        path: '/costcases/caseDetail',
        query: { id: caseItem.id }
      })
    },
    goToEngineerDetail(item) {
      this.$router.push({
        path: '/service/detail',
        query: { id: item.id }
      })
    },
    async fetchUserProfile() {
      try {
        await this.$store.dispatch('user/getInfo')
      } catch (error) {
        console.error('获取用户信息失败:', error)
      }
    },
    async fetchNavLinks() {
      try {
        const response = await getTopNav()
        if (response && response.data) {
          this.navLinks = response.data.map(item => ({
            id: item.id,
            name: item.title,
            path: NAV_PATH_MAP[item.title] || '/'
          }))
        }
      } catch (error) {
        console.error('获取导航数据失败:', error)
        this.navLinks = DEFAULT_NAV_LINKS.slice()
      }
    },
    async fetchRecommendCases() {
      try {
        this.casesLoading = true
        const response = await getRecommendCostCase({ page: 1, limit: 4 })
        if (response && response.data) {
          const list = Array.isArray(response.data) ? response.data : (response.data.list || [])
          this.recommendedCases = list
        }
      } catch (error) {
        console.error('获取推荐案例失败:', error)
        this.recommendedCases = []
      } finally {
        this.casesLoading = false
      }
    },
    async fetchEngineers() {
      try {
        this.engineersLoading = true
        const response = await getEngineerList({ page: 1, limit: 5 })
        if (response && response.data && response.data.list) {
          this.engineers = response.data.list
        }
      } catch (error) {
        console.error('获取造价师列表失败:', error)
        this.engineers = []
      } finally {
        this.engineersLoading = false
      }
    },
    async fetchInitialQuotes() {
      try {
        const [res1, res2] = await Promise.all([getRandomQuote(), getRandomQuote()])
        if (res1 && res1.data && res1.data.content) {
          this.$set(this.quotes, 0, {
            content: res1.data.content,
            author: res1.data.author || ''
          })
        }
        if (res2 && res2.data && res2.data.content) {
          this.$set(this.quotes, 1, {
            content: res2.data.content,
            author: res2.data.author || ''
          })
        }
      } catch (error) {
        console.error('获取名言失败:', error)
      } finally {
        this.quotesReady = true
      }
    },
    async refreshQuote(index) {
      try {
        const response = await getRandomQuote()
        if (response && response.data && response.data.content) {
          this.$set(this.quotes, index, {
            content: response.data.content,
            author: response.data.author || ''
          })
        } else {
          this.$set(this.quotes, index, { content: '', author: '' })
        }
      } catch (error) {
        console.error('刷新名言失败:', error)
      }
    },
    getTeamAvatar(avatar) {
      if (!avatar) return this.images.zjs2
      return avatar.startsWith('http') ? avatar : this.$getImageUrl(avatar)
    },
    async fetchTeamList() {
      try {
        this.teamLoading = true
        const response = await getTeamList()
        if (response && response.data) {
          const list = Array.isArray(response.data) ? response.data : (response.data.list || [])
          this.teamList = list
        }
      } catch (error) {
        console.error('获取管理团队失败:', error)
        this.teamList = []
      } finally {
        this.teamLoading = false
      }
    },
    async fetchStatistics() {
      try {
        const response = await getIndexStatistic()
        if (response && response.data) {
          this.statistics = {
            cost_engineer_count: response.data.cost_engineer_count != null ? response.data.cost_engineer_count : DEFAULT_STATISTICS.cost_engineer_count,
            monthly_customer_problem_count: response.data.monthly_customer_problem_count != null ? response.data.monthly_customer_problem_count : DEFAULT_STATISTICS.monthly_customer_problem_count,
            major: response.data.major != null ? response.data.major : DEFAULT_STATISTICS.major
          }
        }
      } catch (error) {
        console.error('获取统计数据失败:', error)
      }
    },
    onAuthSuccess() {
      this.memberAuthVisible = false
      this.proAuthVisible = false
      this.fetchUserProfile()
    },
    handleNavClick(item) {
      if (item && item.path) {
        this.$router.push(item.path)
      }
    },
    goToMsg() {
      this.$router.push({ path: '/profile/index', query: { activeMenu: '12' }})
    },
    async showCustomerQrcode() {
      this.qrcodeDialogVisible = true
      this.qrcodeUrl = ''
      try {
        const res = await getCustomerQrcode()
        if (res && res.code === 1 && res.data) {
          this.qrcodeUrl = res.data
        } else {
          this.$message.error(res?.msg || '获取二维码失败')
        }
      } catch (e) {
        this.$message.error('获取二维码失败')
      }
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      window.location.replace('https://fww.jpjjjq.com/web/#/news_home')
    },
    goToMembership() {
      this.userDropdownVisible = false
      this.$router.push({
        path: '/profile/index',
        query: { activeMenu: '5' }
      })
    },
    goToRealNameAuth() {
      this.userDropdownVisible = false
      this.$router.push('/profile/shiming')
    },
    goToWallet() {
      this.userDropdownVisible = false
      this.$router.push({
        path: '/profile/index',
        query: { activeMenu: '3' }
      })
    },
    goToSettings() {
      this.userDropdownVisible = false
      this.$router.push({
        path: '/profile/index',
        query: { activeMenu: '11' }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.news-home {
  background: #F1F4F8;
  min-height: 100vh;
  color: #2d2d2d;
  font-family: 'Microsoft YaHei', sans-serif;
}

.news-home-sticky-header {
  position: sticky;
  top: 0;
  z-index: 1000;
  background: #F1F4F8;
}

.sticky-nav-panel {
  width: 1200px;
  margin: 0 auto;
  background: #fff;
  border: 1px solid #e1e1e1;
  border-bottom: none;
  padding: 12px 16px 16px;
  box-sizing: border-box;
}

.topbar {
  width: 1200px;
  margin: 0 auto;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
  color: #6f6f6f;
}

.topbar-left > span { margin-right: 20px; }
.topbar-link {
  cursor: pointer;
  user-select: none;
}
.topbar-link:hover {
  color: #2E65D1;
}
.country {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
}
.country-arrow {
  margin-left: 4px;
  font-size: 12px;
  color: #999;
}
.flag-cn { width: 17px; height: 12px; object-fit: cover; margin-right: 6px; }

.topbar-right { display: flex; align-items: center; gap: 10px; }
.topbar-msg-btn {
  width: 56px;
  height: auto;
  cursor: pointer;
  flex-shrink: 0;
}
.user-avatar-dropdown {
  display: inline-flex;
}
.avatar-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #ECF2FF;
  padding: 8px 16px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.avatar-wrapper:hover {
  background: #e6f3ff;
  transform: translateY(-1px);
}
.avatar-wrapper .user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
}
.avatar-wrapper .user-info-wrapper {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.avatar-wrapper .user-name-line {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}
.avatar-wrapper .identity-chip {
  font-size: 12px;
  color: #0f6fe2;
  background: rgba(15, 111, 226, 0.12);
  padding: 2px 8px;
  border-radius: 10px;
  font-weight: 600;
  white-space: nowrap;
}
.avatar-wrapper .username {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}
.avatar-wrapper .member-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: linear-gradient(135deg, #FFE082 0%, #FFCC02 100%);
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 11px;
  color: #E65100;
  font-weight: 600;
}
.avatar-wrapper .member-days {
  font-size: 11px;
  white-space: nowrap;
}
.avatar-wrapper .dropdown-arrow {
  width: 18px;
}

.btn-blue-outline,
.btn-blue {
  height: 34px;
  border-radius: 6px;
  padding: 0 14px;
  border: none;
  font-size: 12px;
  cursor: pointer;
}
.btn-blue-outline { background: #244c9e; color: #fff; }
.btn-blue { background: #1d3f83; color: #fff; }

.brand { text-align: center; margin: 10px 0 24px; }
.brand-logo-wrap {
  width: 100px;
  height: 100px;
  margin: 0 auto 8px;
  background: #ffffff;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 8px;
}
.brand-logo {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}
.brand-name { font-size: 12px; color: #4c4c4c; }

.panel {
  width: 1200px;
  background: #fff;
  margin: 0 auto 34px;
  border: 1px solid #e1e1e1;
  padding: 12px 16px 16px;
  box-sizing: border-box;
}

.panel.panel-first {
  margin-top: 0;
  border-top: none;
  padding-top: 0;
}

.panel.second {
  margin-bottom: 48px;
  padding-bottom: 24px;
}

.tabs {
  text-align: center;
  font-size: 15px;
  font-weight: 700;
  color: #111111;
}
.tabs span { margin: 0 8px; }
.tab-link {
  cursor: pointer;
  transition: color 0.2s;
}
.tab-link:hover {
  color: #2E65D1;
}
.tab-divider {
  display: inline-block;
  width: 2px;
  height: 15px;
  background: #2E65D1;
  margin-right: 25px;
  margin-left: 25px;
  vertical-align: middle;
}
.search-box {
  display: inline-flex;
  align-items: stretch;
  margin-left: 8px;
  vertical-align: middle;
  width: 320px;
  max-width: 28vw;
  height: 32px;
  border: 1px solid #2E65D1;
  border-radius: 16px;
  background: #ffffff;
  box-sizing: border-box;
  overflow: hidden;
}
.search-box.is-focused {
  border-color: #2E65D1;
}
.search-line {
  flex: 1;
  min-width: 0;
  width: auto;
  height: 100%;
  border-radius: 0;
  background: transparent;
  line-height: 30px;
  padding: 0 8px 0 12px;
  font-size: 13px;
  color: #111111;
  border: none;
  outline: none;
  box-sizing: border-box;
}
.search-line::placeholder {
  color: #666666;
}
.search-box-divider {
  width: 1px;
  align-self: center;
  height: 18px;
  background: #2E65D1;
  flex-shrink: 0;
}
.search-trigger {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  flex-shrink: 0;
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  color: #2E65D1;
}
.search-trigger-icon {
  width: 16px;
  height: 16px;
  display: block;
}

.panel-body { display: flex; }
.left {
  flex: 1;
  min-width: 0;
  padding-right: 18px;
  overflow: hidden;
}
.right {
  flex: 0 0 320px;
  border-left: 2px solid #b4c6e6;
  padding-left: 16px;
  background: #ffffff;
  box-sizing: border-box;
}
.panel-body.second-panel {
  align-items: flex-start;
  padding-bottom: 8px;
}
.panel-body.second-panel .right.stats {
  align-self: auto;
}

.title { font-size: 14px; font-weight: 700; margin-bottom: 12px; }
.group { margin-bottom: 40px; }
.group-title { font-size: 12px; font-weight: 700; margin-bottom: 6px; }

.case-row { display: flex; gap: 30px; }
.case-item {
  display: flex;
  align-items: center;
  width: 44%;
  cursor: pointer;
}
.thumb { width: 74px; height: 74px; object-fit: cover; margin-right: 8px; }
.text {
  width: 150px;
  font-size: 12px;
  color: #4f4f4f;
  line-height: 1.25;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.cases-wrap {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  gap: 18px;
}

.cases-main {
  flex: 1;
  min-width: 0;
}

.cases-more {
  width: 240px;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.more-q {
  font-size: 14px;
  color: #3D3D3D;
  font-weight: 600;
}

.more-link {
  width: 100%;
  text-align: right;
  font-size: 14px;
  color: #2a4f96;
  text-decoration: none;
}

.experts {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.expert-card {
  border: 1px solid #9db6d8;
  background: #ffffff;
  padding: 0;
  min-width: 0;
  text-align: left;
  width: 120px;
  cursor: pointer;
}

.expert-photo {
  width: 120px;
  height: 96px;
  object-fit: cover;
  display: block;
  background: #eef3fb;
}

.expert-meta {
  margin-top: 8px;
  padding: 6px 8px 10px;
}

.expert-title {
  font-size: 14px;
  font-weight: 700;
  color: #15304B;
  line-height: 1.2;
  margin-bottom: 6px;
  white-space: normal;
  overflow-wrap: anywhere;
}

.expert-sub {
  font-size: 12px;
  color: #285482;
  line-height: 1.3;
  white-space: normal;
  overflow-wrap: anywhere;
}

.team-card {
  border: 1px solid #d8dfe8;
  background: #f8fbff;
  padding: 0;
  text-align: center;
}

.avatar { width: 100%; height: 74px; object-fit: cover; }
.expert-name { margin-top: 3px; font-size: 11px; color: #3a3a3a; }

.quote {
  font-size: 22px;
  line-height: 1.5;
  font-weight: 600;
  color: #4e4e4e;
  margin-bottom: 12px;
  white-space: normal;
  overflow-wrap: anywhere;
}
.quote-block.second { margin-top: 52px; }
.author, .arrows { text-align: right; font-size: 22px; color: #2f2f2f; margin-bottom: 4px; }
.arrows { cursor: pointer; }
.arrow-icon { width: 48px; height: 14px; object-fit: contain; }

.section-loading,
.section-empty {
  font-size: 13px;
  color: #999;
  padding: 12px 0;
}

.second-panel .left, .second-panel .right { padding-top: 16px; }
.intro-box {
  width: 520px;
  background: transparent;
  padding: 18px 18px 14px;
  margin: 0 auto;
}
.intro-box h3 {
  font-size: 28px;
  font-weight: 800;
  margin: 0 0 10px;
  display: inline-block;
  padding-bottom: 8px;
  border-bottom: 2px solid #6f8fc4;
}
.intro-box ul {
  margin: 0;
  padding-left: 18px;
  font-size: 13px;
  line-height: 2.1;
  color: #2f2f2f;
}
.team-title {
  text-align: center;
  margin: 80px 0 20px;
  font-size: 18px;
  font-weight: 700;
  color: #2f2f2f;
  width: 520px;
  margin-left: auto;
  margin-right: auto;
}
.team-row {
  display: flex;
  gap: 12px;
  width: 520px;
  justify-content: center;
  margin: 0 auto;
}
.team-card {
  flex: 0 0 120px;
  border: 1px solid #d8dfe8;
  background: #ffffff;
  text-align: left;
}
.team-card .avatar {
  height: 96px;
}
.team-meta {
  padding: 0 6px 10px;
}
.team-head {
  display: flex;
  align-items: baseline;
  gap: 4px;
}
.team-name {
  font-size: 12px;
  font-weight: 700;
  color: #00A8AE;
  line-height: 1.2;
}
.team-role {
  font-size: 10px;
  color: #111111;
  line-height: 1.2;
}
.team-bio {
  margin-top: 6px;
  font-size: 10px;
  color: #666666;
  line-height: 1.2;
  white-space: normal;
  overflow-wrap: anywhere;
}

.stats .metric { font-size: 16px; margin-bottom: 12px; }
.stats .metric {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 10px;
  text-align: center;
  font-size: 16px;
  margin-bottom: 12px;
}
.stats .metric b { font-size: 34px; }
.divider { height: 1px; background: #9bb3d7; margin: 18px 0; }
.city-title { font-weight: 800; margin-bottom: 10px; font-size: 18px; color: #111111; }
.city-grid { display: grid; grid-template-columns: repeat(6, 1fr); gap: 10px 18px; font-size: 13px; color: #2f2f2f; }
.city-item {
  cursor: pointer;
  transition: color 0.2s;
}
.city-item:hover {
  color: #2E65D1;
}
.city-item.active {
  color: #2E65D1;
  font-weight: 700;
}
.city-tip {
  margin-top: 14px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 800;
  color: #111111;
}

.stats {
  padding-bottom: 8px;
}

.news-home-footer {
  width: 100%;
  margin-top: 34px;
}

@media (max-width: 1366px) {
  .topbar,
  .sticky-nav-panel,
  .panel {
    width: 96%;
    max-width: 100%;
    box-sizing: border-box;
  }
}

@media (max-width: 1280px) {
  .topbar,
  .sticky-nav-panel,
  .panel {
    width: 98%;
  }
}
</style>

<style lang="scss">
.news-home-location-dropdown {
  width: 520px;
  max-width: 92vw;
  padding: 12px 16px;
  box-sizing: border-box;

  .popular-regions-header {
    margin-bottom: 12px;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
  }

  .header-label {
    display: block;
    font-size: 13px;
    color: #999;
    margin-bottom: 8px;
  }

  .popular-regions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .popular-region-item,
  .region-item {
    padding: 4px 10px;
    border-radius: 4px;
    font-size: 13px;
    color: #333;
    cursor: pointer;
    background: #f5f5f5;

    &:hover,
    &.active {
      background: #2E65D1;
      color: #fff;
    }
  }

  .region-categories {
    max-height: 320px;
    overflow-y: auto;
  }

  .region-category {
    margin-bottom: 10px;
  }

  .category-name {
    font-size: 12px;
    color: #999;
    margin-bottom: 6px;
  }

  .region-items {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
}

.news-home-user-dropdown {
  min-width: 300px;
  padding: 0;

  .user-info-section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;

    .user-avatar-info {
      display: flex;
      align-items: center;
      gap: 15px;

      .dropdown-avatar {
        width: 70px;
        height: 70px;
        border-radius: 50%;
        object-fit: cover;
      }

      .user-details {
        .username {
          font-size: 16px;
          font-weight: 600;
          color: #333;
          margin-bottom: 8px;
        }

        .user-status {
          .status-badge {
            display: inline-flex;
            align-items: center;
            color: #0f6fe2;
            padding: 4px 0;
            border-radius: 20px;
            font-size: 15px;
            font-weight: 500;
          }

          .status-badge.member-status {
            color: #FF6F00;
            background: linear-gradient(135deg, rgba(255, 224, 130, 0.3) 0%, rgba(255, 204, 2, 0.3) 100%);
            padding: 4px 12px;
          }

          .status-badge.role-badge {
            color: #0f6fe2;
            font-weight: 600;
            padding: 4px 0;
          }

          .member-days-text {
            font-size: 13px;
            color: #E65100;
            margin-left: 4px;
          }
        }
      }
    }

    .logout-btn {
      background: #f5f5f5;
      color: #666;
      border: none;
      border-radius: 6px;
      padding: 8px 16px;
      font-size: 12px;

      &:hover {
        background: #e8e8e8;
        color: #333;
      }
    }
  }

  .membership-section {
    width: 100%;
  }

  .vip-text {
    width: 100px;
    height: 50px;
    color: #fff;
    background: #601f00;
    border-radius: 100px;
    text-align: center;
    line-height: 50px;
    position: absolute;
    right: 30px;
    top: 50%;
    transform: translateY(-50%);
  }

  .profile-options {
    padding: 0 30px 15px;

    .option-item {
      display: flex;
      align-items: center;
      padding: 15px 0;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        background: #f8f9fa;
        padding: 15px 10px;
        margin: 0 -10px;
        border-radius: 8px;
      }

      .option-icon {
        width: 20px;
        height: 20px;
        margin-right: 15px;
        object-fit: contain;
      }

      .option-text {
        flex: 1;
        font-size: 14px;
        color: #333;
        font-weight: 500;
      }

      .arrow-icon {
        width: 16px;
        height: 16px;
        object-fit: contain;
      }
    }
  }
}
</style>
